var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 13.461V17.461C6 18.011 6.45 18.461 7 18.461H10L13.29 21.751C13.92 22.381 15 21.931 15 21.041V9.87102C15 8.98102 13.92 8.53102 13.29 9.16102L10 12.461H7C6.45 12.461 6 12.911 6 13.461ZM19.5 15.461C19.5 13.691 18.48 12.171 17 11.431V19.481C18.48 18.751 19.5 17.231 19.5 15.461ZM17 7.91102V8.11102C17 8.49102 17.25 8.82102 17.6 8.96102C20.18 9.99102 22 12.521 22 15.461C22 18.401 20.18 20.931 17.6 21.961C17.24 22.101 17 22.431 17 22.811V23.011C17 23.641 17.63 24.081 18.21 23.861C21.6 22.571 24 19.301 24 15.461C24 11.621 21.6 8.35102 18.21 7.06102C17.63 6.83102 17 7.28102 17 7.91102Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume_up.c6708032960899a8816f5b927ffd531a.svg";
export { ForwardRef as ReactComponent };